import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";

interface ArticleCardProps {
  article: {
    id: string;
    title: string;
    excerpt: string;
    publishDate: string;
  };
  index: number;
}

export default function ArticleCard({ article, index }: ArticleCardProps) {
  const navigate = useNavigate();

  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  const handleArticleClick = () => {
    // Navigate to individual article page
    navigate(`/insights/${article.id}`);
  };

  return (
    <motion.article
      className="bg-white border border-slate-200/60 rounded-xl p-6 hover:shadow-xl transition-all duration-300 hover:border-cyan-400/30 cursor-pointer"
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: index * 0.1 }}
      viewport={{ once: true }}
      whileHover={{ y: -2 }}
      onClick={handleArticleClick}
    >
      <div className="space-y-4">
        {/* Title */}
        <h3 className="text-xl font-semibold text-foreground hover:text-cyan-600 transition-colors duration-300">
          {article.title}
        </h3>

        {/* Excerpt */}
        <p className="text-sm text-muted-foreground line-clamp-3">
          {article.excerpt}
        </p>

        {/* Date and Read More */}
        <div className="flex items-center justify-between pt-4 border-t border-slate-100">
          <span className="text-xs text-muted-foreground">
            {formatDate(article.publishDate)}
          </span>

          {/* Read More Link */}
          <motion.button
            className="text-cyan-600 hover:text-cyan-700 text-sm font-medium flex items-center gap-1"
            whileHover={{ x: 3 }}
            whileTap={{ scale: 0.95 }}
            onClick={(e) => {
              e.stopPropagation();
              handleArticleClick();
            }}
          >
            Read More
            <svg 
              className="w-4 h-4" 
              fill="none" 
              stroke="currentColor" 
              viewBox="0 0 24 24"
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
            </svg>
          </motion.button>
        </div>
      </div>
    </motion.article>
  );
}